export default __webpack_public_path__ + "static/media/meadow.749f4202.jpg";